<mat-card class="filter settingHeader">
  <div class="name">
    Manage AI Automation Templates
  </div>

  <div class="quickAction">
    <mat-form-field class="example-form-field" appearence="fill">
      <mat-label>Search AI Automation Template</mat-label>
      <input matInput type="text"  [(ngModel)]="value" (keyup)="$event.keyCode == 13 ? Search($event.target.value) : ($event.target.value==''?Search($event.target.value):null)" >
      <button mat-button *ngIf="value" matSuffix mat-icon-button aria-label="Clear" (click)="clearFilter()">
        <mat-icon>close</mat-icon>
      </button>
      <button  *ngIf="!value" matSuffix mat-icon-button aria-label="Clear" (click)="clearFilter()">
        <mat-icon>search</mat-icon>
      </button>
    </mat-form-field>

    <div class="">         
      <button mat-flat-button color="primary" (click)="openAddTemplates(addAIDialog)"> Add Templates </button>
   </div>

  </div>
</mat-card>


 <div class="documents">

  <mat-card class="example-list rowholder" *ngIf="!ShowNoRecordFound">
    <div class="fieldRow head">          
      <span class="fieldName">Automation Template</span> 
      <span class="fieldName">Field Template</span> 
      <span class="fieldName">Question Template</span>      
      <span class="editField">Edit</span>
      <span class="delete">Delete</span>
    </div>
  
    <div class="example-box fieldRow" *ngFor="let temp of aITemplateList">
     
      <span class="fieldName">           
        {{temp.name}}      
      </span>        
      
      <span class="fieldName ">           
        <div class="fieldWrapper" [ngClass]="{'noContent' : !temp.fieldTemplateName}">
          {{temp.fieldTemplateName}}  
          <div class="act">
            <button mat-icon-button matTooltip="Add Field Template" (click)="selectFieldTemplate(temp)">
              <mat-icon>add</mat-icon>
             </button>  
             <button mat-icon-button matTooltip="Remove Field Template" *ngIf="temp.fieldTemplateName!=''"
             (click)="removeFieldTemplate(temp)">
              <mat-icon>close</mat-icon>
             </button>  
          </div>
        </div>
      </span>       

    

      <span class="fieldName">           

        <div class="fieldWrapper" [ngClass]="{'noContent' : !temp.promptTemplateName}">
          {{temp.promptTemplateName}}  
          
          <div class="act">
            <button mat-icon-button matTooltip="Add Question Template" (click)="selectPromptTemplate(temp)">
              <mat-icon>add</mat-icon>
             </button>
             <button mat-icon-button matTooltip="Remove Question Template" *ngIf="temp.promptTemplateName!=''"
             (click)="removePromptTemplate(temp)">
              <mat-icon>close</mat-icon>
             </button> 
          </div>
        </div>

        
      </span>        
      
      <span class="editField">
        <button mat-icon-button class="editbtn" (click)="UpdateAITempDialog(addAIDialog,temp)">
          <mat-icon>edit</mat-icon>
        </button>
      </span>

      <ng-container>            
          <span class="delete">
          <button mat-icon-button class="trash" (click)="deleteAIAutomationTemplate(temp)">
            <mat-icon>delete_outline</mat-icon>
          </button>
        </span>
      </ng-container>

    </div>          
  </mat-card>
  <div *ngIf="ShowNoRecordFound" class="noRecordFound">No Record Found</div>
</div> 


<ng-template #addAIDialog> 
  <h2 mat-dialog-title>
      {{TitleName}} AI Automation Template
      <button mat-icon-button (click)="closeUpdate()">
      <mat-icon>close</mat-icon>
      </button>
  </h2>
  
<mat-dialog-content class="mat-typography">  
 
  <mat-form-field class="example-half-width">
    <mat-label>Template Name</mat-label>
    <input matInput [required]="true" [(ngModel)]="templateName" maxlength="100" 
    placeholder="Add template name" (input)="onChangeTemplateName($event.target.value)"/>          
  </mat-form-field>
   
   <!-- <div *ngIf="PromptTemplateName!=''"> 
    {{PromptTemplateName}}       
   </div>

   <button mat-flat-button color="primary" (click)="selectPromptTemplate()">
    Select Question Template 
   </button>
   <br>
   <br>
   <br>
   <div *ngIf="FieldTemplateName!=''"> 
    {{FieldTemplateName}}      
   </div>
   <button mat-flat-button color="primary" (click)="selectFieldTemplate()">
    Select Field Template 
   </button> -->
  

</mat-dialog-content>

<mat-dialog-actions class="dialog-actions">
  <button mat-button (click)="closeUpdate()">Cancel</button>
  <button mat-flat-button color="primary" *ngIf="aiAutomationTemplateID==0"
  [disabled]="showAddUpdateButton" (click)="addAIAutomationTemplate()">
  Add
  <mat-icon *ngIf="spinner"><mat-spinner diameter="20">
  </mat-spinner></mat-icon>
  </button>
  <button mat-flat-button color="primary" *ngIf="aiAutomationTemplateID>0"
    [disabled]="showAddUpdateButton" (click)="addAIAutomationTemplate()">
   Update
  <mat-icon *ngIf="spinner"><mat-spinner diameter="20">
  </mat-spinner></mat-icon>
  </button>
</mat-dialog-actions>

</ng-template>


<app-loader></app-loader>